// @ts-nocheck
import { BasePDFTemplateRequest } from './base/BasePDFTemplate.request';

import type { IntlShape } from 'react-intl/src/types';

export class ReportingTemplateRequest extends BasePDFTemplateRequest {
  private formatMessage: IntlShape['formatMessage'];

  private currencyInfo: Record<string, any>;

  reportName: string[];

  constructor(formatMessage: IntlShape['formatMessage'], currencyInfo: Record<string, any>, reportName: string[]) {
    super('reporting-base-template-with-subtemplateId');
    this.formatMessage = formatMessage;
    this.currencyInfo = currencyInfo;
    this.reportName = reportName;
    this.data = {
      dataPages: [],
      reportName: reportName.join('</br>')
    };
  }

  toRequest() {
    return this.toAPIRequest();
  }
}
